// TermsPage — renders docs/terms.md as a public, no-auth page.
// Route: /terms (public, outside RequireAuth)
import content from '../../../docs/terms.md?raw';

export function TermsPage() {
  return (
    <div className="min-h-screen bg-background">
      <div className="mx-auto max-w-2xl px-6 py-12">
        <pre className="whitespace-pre-wrap font-sans text-sm leading-relaxed text-foreground">
          {content}
        </pre>
      </div>
    </div>
  );
}
